const LINK = /\[([^\]]+)\]\((https?:\/\/[^)\s]+)\)/g;

const inline = (text) => {
  const out = [];
  let last = 0;
  text.replace(LINK, (m, label, href, idx) => {
    out.push(text.slice(last, idx));
    out.push(
      <a key={idx} href={href} target="_blank" rel="noopener noreferrer" className="text-teal underline decoration-sage underline-offset-4 hover:decoration-teal">
        {label}
      </a>
    );
    last = idx + m.length;
    return m;
  });
  out.push(text.slice(last));
  return out;
};

const toBlocks = (text) =>
  String(text || "")
    .split(/\n\s*\n/)
    .map((b) => b.trim())
    .filter(Boolean)
    .flatMap((b) => {
      if (!b.startsWith("## ")) return [b];
      const [head, ...rest] = b.split("\n");
      return rest.length ? [head, rest.join("\n")] : [head];
    });

export const RichText = ({ text = "", className = "" }) => {
  const blocks = toBlocks(text);
  return (
    <div className={`rich space-y-6 text-[17px] leading-[1.8] text-teal-ink/90 ${className}`}>
      {blocks.map((b, i) => {
        if (b.startsWith("## ")) {
          return (
            <h3 key={i} className="!mt-12 font-display text-2xl font-normal tracking-tight text-teal sm:text-3xl">
              {b.slice(3)}
            </h3>
          );
        }
        if (b.startsWith("> ")) {
          return (
            <blockquote key={i} className="!my-10 border-l-2 border-sage pl-6 font-display text-2xl font-light leading-snug text-teal sm:text-3xl">
              {inline(b.slice(2))}
            </blockquote>
          );
        }
        if (b.startsWith("Source:")) {
          return (
            <p key={i} className="!mt-12 border-t border-teal/15 pt-6 font-mono text-xs uppercase tracking-[0.12em] text-teal/75">
              {b}
            </p>
          );
        }
        const lines = b.split("\n");
        if (lines.every((l) => l.trim().startsWith("- "))) {
          return (
            <ul key={i} className="space-y-3">
              {lines.map((l, j) => (
                <li key={j} className="flex gap-4">
                  <span className="mt-[0.75em] h-1.5 w-1.5 shrink-0 rounded-full bg-sage" />
                  <span>{inline(l.trim().slice(2))}</span>
                </li>
              ))}
            </ul>
          );
        }
        return (
          <p key={i}>
            {lines.map((l, j) => (
              <span key={j}>
                {inline(l)}
                {j < lines.length - 1 && <br />}
              </span>
            ))}
          </p>
        );
      })}
    </div>
  );
};
